import { render } from "./SiteChoiceView.vue?vue&type=template&id=30af5c72"
import script from "./SiteChoiceView.vue?vue&type=script&lang=js"
export * from "./SiteChoiceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__